import { Progress as _Progress } from 'antd';
import styled, { css } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

export const Progress = styled(_Progress)`
  .ant-progress-text {
    color: ${({ theme }) => theme.headerColor} !important;
  }

  // antd's translucent-black track disappears on dark surfaces.
  ${({ theme }) =>
    theme.themeName === Theme.Dark
      ? css`
          .ant-progress-circle-trail {
            stroke: ${theme.borderColor};
          }

          &.ant-progress-line .ant-progress-inner {
            background: ${theme.borderColor};
          }
        `
      : ''}
`;
